/* Operational controls for the Recharge bundle widget. Never changes a selling plan or product selection. */
(function () {
  'use strict';

  function supplyMonths(label) {
    var value = String(label || '').trim();
    if (/^30[\s-]*day\s+supply$/i.test(value)) return 1;
    var match = value.match(/^(1|3|6|12)[\s-]*month\s+supply$/i);
    return match ? Number(match[1]) : null;
  }

  function cadenceMonths(name) {
    var match = String(name || '').match(/\b(1|3|6|12)\s*months?\b/i);
    return match ? Number(match[1]) : null;
  }

  function validateConfiguration(items, planId, plans, enforceSupply) {
    var quantity = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var result = { valid: true, code: null, quantity: quantity, months: null, planMonths: null, subscription: planId !== '0' };
    if (!quantity) return result; // Recharge continues to enforce its own bundle minimum.
    if (items.some(function (item) { return !item.valid; })) {
      result.valid = false; result.code = 'unavailable_variant'; return result;
    }
    if (planId === '0') return result;
    var plan = plans.find(function (entry) { return String(entry.id) === planId; });
    result.planMonths = plan ? cadenceMonths(plan.name) : null;
    if (!plan || !result.planMonths) {
      result.valid = false; result.code = 'no_plan'; return result;
    }
    if (!enforceSupply) return result;
    var supplies = Array.from(new Set(items.map(function (item) { return item.months; })));
    if (supplies.indexOf(null) !== -1) {
      result.valid = false; result.code = 'unknown_supply'; return result;
    }
    if (supplies.length > 1) {
      result.valid = false; result.code = 'mixed_supply'; return result;
    }
    result.months = supplies[0];
    if (result.months !== result.planMonths) {
      result.valid = false; result.code = 'cadence_mismatch';
    }
    return result;
  }

  // Export the same decision logic used by the storefront for isolated verification.
  if (typeof module === 'object' && module.exports) {
    module.exports = { supplyMonths: supplyMonths, cadenceMonths: cadenceMonths, validateConfiguration: validateConfiguration };
  }
  if (typeof document === 'undefined') return;

  function start() {
    var dataNode = document.getElementById('patchaid-bundle-data');
    if (!dataNode || dataNode.dataset.initialized === 'true') return;
    var config;
    try { config = JSON.parse(dataNode.textContent); } catch (_) { return; }
    dataNode.dataset.initialized = 'true';
    var strings = config.strings || {};
    var wellnessHandles = ['vitamin-patch-bundle-for-adults', 'vitamin-patch-bundle-for-kids'];
    var enforceSupply = wellnessHandles.indexOf(config.handle) !== -1;
    var summarySelector = '.recharge-bundle-summary-sidebar, .recharge-bundle-summary-sticky-bar';
    var root, observer, queued = false, tools, search, results, clear, filterButtons;
    var filter = 'first', query = '', lastMeasurement = '';
    var ownedInert = new WeakSet();
    var views = new Map();
    var nextId = 0;

    function text(key, values) {
      var value = strings[key] || '';
      Object.keys(values || {}).forEach(function (name) { value = value.split('[' + name + ']').join(String(values[name])); });
      return value;
    }
    function setText(node, value) { if (node.textContent !== value) node.textContent = value; }
    function setAttribute(node, key, value) { if (node.getAttribute(key) !== value) node.setAttribute(key, value); }
    function cards() { return Array.from(root.querySelectorAll('.recharge-bundle-product-item')); }
    function selectedItems() {
      var selected = new Map();
      cards().forEach(function (card) {
        var input = card.querySelector('input[type="number"]');
        var quantity = Number(input && input.value);
        if (!Number.isInteger(quantity) || quantity <= 0) return;
        var select = card.querySelector('select');
        var variantId = card.getAttribute('data-recharge-variant-id');
        var option = select && Array.from(select.options).find(function (entry) { return entry.value === variantId; });
        var valid = Boolean(variantId && select && select.value === variantId && option && !option.disabled);
        var item = { quantity: quantity, months: supplyMonths(option && option.textContent), valid: valid };
        var key = card.getAttribute('data-recharge-product-id') + ':' + variantId;
        if (!selected.has(key) || selected.get(key).quantity < quantity) selected.set(key, item);
      });
      return Array.from(selected.values());
    }
    function readPlan() {
      var values = [];
      root.querySelectorAll(summarySelector).forEach(function (summary) {
        summary.querySelectorAll('select').forEach(function (select) {
          if (select.querySelector('option[value="0"]')) values.push(select.value);
        });
      });
      var unique = Array.from(new Set(values));
      return unique.length === 1 ? unique[0] : '';
    }
    function state() { return validateConfiguration(selectedItems(), readPlan(), config.plans || [], enforceSupply); }
    function addButtons() {
      var buttons = [];
      root.querySelectorAll(summarySelector).forEach(function (summary) {
        summary.querySelectorAll('button.recharge-button-primary').forEach(function (button) { buttons.push(button); });
      });
      return buttons;
    }
    function isAddButton(target) {
      var button = target instanceof Element ? target.closest('button.recharge-button-primary') : null;
      return button && button.closest(summarySelector) && root.contains(button) ? button : null;
    }
    function measure(result, canSubmit) {
      var signature = [result.valid, result.code, result.quantity, result.months, result.planMonths, result.subscription].join('|');
      if (!result.quantity || (result.valid && !canSubmit) || signature === lastMeasurement) return;
      lastMeasurement = signature;
      var payload = { component: 'bundle', purchase_type: result.subscription ? 'subscription' : 'one_time', quantity: result.quantity };
      var name = 'bundle_ready';
      if (!result.valid) {
        name = 'bundle_configuration_blocked';
        payload.error_code = result.code === 'unknown_supply' ? 'unavailable_variant' : result.code;
      } else if (result.months) payload.supply_months = result.months;
      document.dispatchEvent(new CustomEvent('patchaid:measure', { detail: { name: name, data: payload } }));
    }
    function updateSummaries(result) {
      var buttons = addButtons();
      views.forEach(function (view, button) { if (!buttons.includes(button)) { view.wrapper.remove(); views.delete(button); } });
      buttons.forEach(function (button) {
        var view = views.get(button);
        if (!view) {
          var wrapper = document.createElement('div');
          wrapper.className = 'patchaid-bundle-operational';
          var summary = document.createElement('div'); summary.className = 'patchaid-bundle-summary';
          var contents = document.createElement('p'); contents.className = 'patchaid-bundle-contents';
          var recurring = document.createElement('p');
          var costs = document.createElement('p'); costs.textContent = text('checkout_costs');
          summary.append(contents, recurring, costs);
          var warning = document.createElement('p');
          warning.id = 'patchaid-bundle-validation-' + (++nextId);
          warning.className = 'patchaid-bundle-validation'; warning.setAttribute('role', 'alert'); warning.tabIndex = -1; warning.hidden = true;
          wrapper.append(summary, warning);
          view = { wrapper: wrapper, summary: summary, contents: contents, recurring: recurring, warning: warning };
          views.set(button, view);
        }
        // Existing estimate note stays immediately before its button; avoid competing observer placements.
        var anchor = button.previousElementSibling;
        if (!anchor || !anchor.classList.contains('patchaid-bundle-estimate')) anchor = button;
        if (anchor.previousElementSibling !== view.wrapper) anchor.before(view.wrapper);
        view.summary.hidden = !result.quantity;
        var contents = text('selection_count', { count: result.quantity });
        if (result.months) contents += ' · ' + text('supply', { months: result.months });
        setText(view.contents, contents);
        var recurring = result.subscription ? (result.planMonths ? (result.planMonths === 1 ? text('recurring_month') : text('recurring', { months: result.planMonths })) : '') : text('one_time');
        // Repeat the existing displayed estimate verbatim; do not recalculate Recharge discounts.
        var price = button.querySelector('[aria-label*="Estimated total"], [aria-label*="Actual price"]');
        var estimate = price && price.getAttribute('aria-label').match(/(?:Estimated total|Actual price)\s+(.+)$/);
        if (estimate) recurring = text('estimate', { total: estimate[1] }) + ' ' + recurring;
        setText(view.recurring, recurring);
        view.warning.hidden = result.valid;
        setText(view.warning, result.valid ? '' : text(result.code, { months: result.months || result.planMonths || '—' }));
        button.classList.toggle('patchaid-bundle-blocked', !result.valid);
        if (!result.valid) {
          if (!button.hasAttribute('inert')) { button.setAttribute('inert', ''); ownedInert.add(button); }
          setAttribute(button, 'data-patchaid-blocked', 'true');
          var ids = (button.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
          if (!ids.includes(view.warning.id)) setAttribute(button, 'aria-describedby', ids.concat(view.warning.id).join(' '));
        } else {
          if (ownedInert.has(button)) { button.removeAttribute('inert'); ownedInert.delete(button); }
          button.removeAttribute('data-patchaid-blocked');
          var remaining = (button.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) { return id && id !== view.warning.id; });
          if (remaining.length) setAttribute(button, 'aria-describedby', remaining.join(' '));
          else button.removeAttribute('aria-describedby');
        }
      });
      measure(result, buttons.some(function (button) { return !button.disabled && button.getAttribute('aria-disabled') !== 'true'; }));
    }
    function createTools() {
      var container = root.querySelector('.recharge-bundle-collections');
      if (!container) return;
      if (tools && tools.isConnected) return;
      tools = document.createElement('div'); tools.className = 'patchaid-bundle-tools';
      var label = document.createElement('label'); label.htmlFor = 'patchaid-bundle-search'; label.textContent = text('search');
      search = document.createElement('input'); search.id = label.htmlFor; search.type = 'search'; search.autocomplete = 'off'; search.placeholder = text('search_placeholder'); search.value = query;
      var filters = document.createElement('div'); filters.className = 'patchaid-bundle-filters'; filters.setAttribute('role', 'group'); filters.setAttribute('aria-label', text('catalog'));
      filterButtons = {};
      [['first', 'first_products'], ['all', 'all_products'], ['selected', 'selected_products']].forEach(function (entry) {
        var button = document.createElement('button'); button.type = 'button'; button.className = 'patchaid-bundle-filter'; button.textContent = text(entry[1]);
        button.addEventListener('click', function () { filter = entry[0]; if (query) { query = ''; search.value = ''; } updateCatalog(); });
        filterButtons[entry[0]] = button; filters.append(button);
      });
      results = document.createElement('p'); results.className = 'patchaid-bundle-results'; results.setAttribute('role', 'status'); results.setAttribute('aria-live', 'polite');
      clear = document.createElement('button'); clear.type = 'button'; clear.className = 'patchaid-bundle-clear'; clear.textContent = text('clear_search');
      clear.addEventListener('click', function () { query = ''; search.value = ''; filter = 'all'; updateCatalog(); search.focus(); });
      search.addEventListener('input', function () { query = search.value.trim().toLocaleLowerCase(config.locale); if (query) filter = 'all'; updateCatalog(); });
      tools.append(label, search, filters, results, clear);
      container.prepend(tools);
    }
    function updateCatalog() {
      if (!tools || !tools.isConnected) return;
      var list = cards(), shown = 0;
      list.forEach(function (card, index) {
        var heading = card.querySelector('.recharge-bundle-product-titles [role="heading"]');
        var name = (heading && heading.textContent || '').toLocaleLowerCase(config.locale);
        var selected = Number(card.querySelector('input[type="number"]')?.value) > 0;
        var visible = query ? name.includes(query) : (filter === 'all' || (filter === 'selected' ? selected : index < 8 || selected));
        if (visible) shown++;
        setAttribute(card, 'data-patchaid-hidden', visible ? 'false' : 'true');
      });
      Object.keys(filterButtons).forEach(function (key) { setAttribute(filterButtons[key], 'aria-pressed', key === filter ? 'true' : 'false'); });
      setText(results, shown ? text('results', { shown: shown, total: list.length }) : text('no_results'));
      clear.hidden = !query;
    }
    function update() { queued = false; createTools(); updateCatalog(); updateSummaries(state()); }
    function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    function blockInvalidAdd(event) {
      if (event.type === 'keydown' || event.type === 'keyup') {
        if (!['Enter', ' ', 'Spacebar'].includes(event.key)) return;
      }
      var button = isAddButton(event.target);
      if (!button) return;
      var current = state();
      if (current.valid) return;
      event.preventDefault(); event.stopImmediatePropagation();
      updateSummaries(current);
      var view = views.get(button); if (view) view.warning.focus();
    }
    function attach() {
      root = document.getElementById('bundling-app');
      if (!root) return false;
      // Capture pointer/keyboard phases as React Aria may commit a press before the click phase.
      ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'click', 'keydown', 'keyup'].forEach(function (name) {
        root.addEventListener(name, blockInvalidAdd, { capture: true, passive: false });
      });
      root.addEventListener('submit', function (event) {
        var button = event.submitter && isAddButton(event.submitter);
        if (button && !state().valid) { event.preventDefault(); event.stopImmediatePropagation(); update(); }
      }, true);
      root.addEventListener('input', schedule, true); root.addEventListener('change', schedule, true);
      observer = new MutationObserver(schedule);
      observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-recharge-variant-id', 'value', 'selected', 'disabled', 'aria-label'] });
      document.addEventListener('bundling-widget:ready', schedule);
      update(); return true;
    }
    if (!attach()) {
      var waitForRoot = new MutationObserver(function () { if (attach()) waitForRoot.disconnect(); });
      waitForRoot.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
